export { SliderDots } from "./SliderDots";
